import Body from 'iovisit-ferraraterraeacqua/components/Blocks/EventProgram/Body';
const View = (props) => {
  return (
    <div className="block event-program">
      <Body {...props} isEditMode={true} />
    </div>
  );
};
export default View;
